import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const FrustratingDoubleChin = lazyWithPreload(
  () => import('./FrustratingDoubleChin'),
)
